import type {
  ListPlaceholderReload,
} from './types';

export const defaultReload: ListPlaceholderReload = () => {
  window.location.search = '';
};
